"use strict";exports.arrayAt=function(t,e){if(!(e<-t.length||e>=t.length))return e<0&&(e=t.length+e),t[e]};
//# sourceMappingURL=arrayAt.cjs.map
